// components/PdfModal.js
import React from "react";

const PdfModal = ({ isOpen, onClose, pdfUrl }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white w-3/4 h-4/6 rounded-lg overflow-hidden shadow-lg relative">
                <button
                    className="absolute top-2 right-2 text-white bg-red-600 rounded-full w-8 h-8 flex items-center justify-center"
                    onClick={onClose}
                >
                    ✕
                </button>
                <iframe
                    src={pdfUrl}
                    title="PDF Viewer"
                    className="w-full h-full"
                />
            </div>
        </div>
    );
};

export default PdfModal;